import { useAuth0 } from '@brighte/passwordless-authenticator';
import { ApplicationFormStatus } from '@graphql/index';
import { ApplicationSubmissionStatus } from '@pages/ApplicationStatus/types';
import { useApplicationData } from '@provider';
import { APPLICATION_FORM, isJointApplicant } from '@utils';
import { getApprovedPageTitle, getSubmittedPageTitle, getUnderReviewPageTitle } from './helpers';

export const useGetPageTitle = (status?: ApplicationSubmissionStatus) => {
  const {
    HouseholdDetails: householdDetails,
    SubmitApplication: submitApplication,
    quote,
  } = useApplicationData(['HouseholdDetails', 'SubmitApplication', 'quote']);

  const isSubmitted = submitApplication?.status === ApplicationFormStatus.Submitted;
  const isJointForm = isJointApplicant();
  const hasJoint = !!householdDetails?.hasJointApplicant;
  const { user } = useAuth0();

  const renderTitle = () => {
    if (status === ApplicationSubmissionStatus.APPROVED) {
      return getApprovedPageTitle(user);
    }

    // A joint applicant's own session never sets HouseholdDetails, so isJointForm (from the URL)
    // is what actually distinguishes them from a single-applicant session on SUBMITTED/REFERRED.
    const isJointSubmission = hasJoint || isJointForm;
    if (
      !isJointSubmission &&
      (status === ApplicationSubmissionStatus.REFERRED || status === ApplicationSubmissionStatus.SUBMITTED)
    ) {
      return getUnderReviewPageTitle(user);
    }

    if (isSubmitted) {
      return getSubmittedPageTitle(hasJoint, isJointForm);
    }

    const financialProductName = quote?.financialProduct?.name ?? '';

    const applicationFormName = APPLICATION_FORM(financialProductName);

    return applicationFormName[quote?.financialProduct?.id ?? ''] ?? financialProductName;
  };

  return renderTitle();
};
